import { RuleType, CustomPropertyType, EmployeeType } from "winslow-core";

export interface RuleOption {
  id: RuleType;
  label: string;
}

export const RULE_OPTIONS: RuleOption[] = [
  { id: RuleType.IS, label: "Is" },
  { id: RuleType.IS_NOT, label: "Is Not" },
  { id: RuleType.IS_ONE_OF, label: "Is One Of" },
  { id: RuleType.IS_NOT_ONE_OF, label: "Is Not One Of" },
  { id: RuleType.CONTAINS, label: "Contains" },
  { id: RuleType.DOES_NOT_CONTAIN, label: "Does Not Contain" },
  { id: RuleType.BETWEEN, label: "Between" },
  { id: RuleType.NOT_BETWEEN, label: "Not Between" },
];

// Employee Type options for the built-in employeeType condition
export const EMPLOYEE_TYPE_OPTIONS = [
  { value: EmployeeType.US_FULL_TIME, label: "US Full Time" },
  { value: EmployeeType.US_PART_TIME, label: "US Part Time" },
  { value: EmployeeType.US_CONTRACTOR, label: "US Contractor" },
  { value: EmployeeType.US_VENDOR, label: "US Vendor" },
  { value: EmployeeType.INT_FULL_TIME, label: "International Full Time" },
  { value: EmployeeType.INT_CONTRACTOR, label: "International Contractor" },
];

// Get available rules based on attribute type
export const getRulesForAttributeType = (
  attributeType?: CustomPropertyType | "employeeType"
): RuleOption[] => {
  switch (attributeType) {
    case CustomPropertyType.RADIO:
      // Radio button - single value selection, only IS
      return [{ id: RuleType.IS, label: "Is" }];

    case "employeeType":
    case CustomPropertyType.DROPDOWN:
      // Dropdown/select types - single value comparison
      return [
        { id: RuleType.IS, label: "Is" },
        { id: RuleType.IS_NOT, label: "Is Not" },
      ];

    case CustomPropertyType.CHECKBOX_SINGLE:
      // Single checkbox - boolean value
      return [{ id: RuleType.IS, label: "Is" }];

    case CustomPropertyType.CHECKBOX_MULTIPLE:
      // Multiple checkbox - array value, supports exact match and contains
      return [
        { id: RuleType.IS, label: "Is" },
        { id: RuleType.IS_NOT, label: "Is Not" },
        { id: RuleType.CONTAINS, label: "Contains" },
        { id: RuleType.DOES_NOT_CONTAIN, label: "Does Not Contain" },
      ];

    case CustomPropertyType.NUMBER:
      // Number type - string comparison (numbers stored as strings)
      return [
        { id: RuleType.IS, label: "Is" },
        { id: RuleType.IS_NOT, label: "Is Not" },
        { id: RuleType.CONTAINS, label: "Contains" },
        { id: RuleType.DOES_NOT_CONTAIN, label: "Does Not Contain" },
      ];

    case CustomPropertyType.DATE:
      // Date type - range queries only
      return [
        { id: RuleType.BETWEEN, label: "Between" },
        { id: RuleType.NOT_BETWEEN, label: "Not Between" },
      ];

    case CustomPropertyType.SHORT:
    case CustomPropertyType.LONG:
    case CustomPropertyType.EMAIL:
    case CustomPropertyType.PHONE:
    default:
      // String types - text comparison
      return [
        { id: RuleType.IS, label: "Is" },
        { id: RuleType.IS_NOT, label: "Is Not" },
        { id: RuleType.CONTAINS, label: "Contains" },
        { id: RuleType.DOES_NOT_CONTAIN, label: "Does Not Contain" },
      ];
  }
};
